import { FC, memo } from 'react';
import { useQuery } from '@apollo/client';

import { useScript } from 'application/hooks';
import { useAppSelector } from 'application/providers/StoreProvider';
import { selectIsAuthorized } from 'application/store';

import { AuthCurrentUserDocument, AuthCurrentUserQuery, Country } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

import './index.scss';

type UseDeskMessengerType = {
  toggle: (value: boolean) => void;
};

interface UseDeskWindow extends Window {
  usedeskMessenger?: UseDeskMessengerType;
}

export const windowUseDesk: UseDeskWindow = window;

const SUPPORT_WIDGET_URL = 'https://lib.usedesk.ru/secure.usedesk.ru/widget_167020_56071.js';
const SUPPORT_WIDGET_URL_KZ = 'https://lib.usedesk.ru/secure.usedesk.ru/widget_167020_59658.js';

const SupportChat: FC = () => {
  const isAuthorized = useAppSelector(selectIsAuthorized);

  const { data } = useQuery<AuthCurrentUserQuery>(AuthCurrentUserDocument, {
    fetchPolicy: FetchPolicyKeys.CACHE_AND_NETWORK,
    skip: !isAuthorized,
  });

  const companyCountry = data?.currentUserPureQuery?.mainCompany?.country;

  const widgetURL = companyCountry === Country.Kz ? SUPPORT_WIDGET_URL_KZ : SUPPORT_WIDGET_URL;

  useScript(widgetURL, true, () => {
    const windowUseDesk: UseDeskWindow = window;
    windowUseDesk.usedeskMessenger?.toggle(false);
  });

  return null;
};

export default memo(SupportChat);
